// extracted by mini-css-extract-plugin
export var labelWrapper = "_eb-0";